import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translationLabel'
})
export class TranslationLabelPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    switch (value) {
      case 'fr':
        return 'Français';
      case 'en':
        return 'English';
      case 'tn':
        return 'عربي';
    }
  }
}


@Pipe({
  name: 'fromEnToUs'
})
export class CustomFlagNamePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return value === 'en' ? 'us' : value;
  }
}
